<template>
    <v-navigation-drawer
        v-model="active"
        right
        temporary
        fixed
        width="600"
    >
        <v-container class="pa-10">
            <v-row>
                <v-col cols="12">
                    <v-row no-gutters align="center">
                        <v-btn icon class="black--text" @click="onBackSelected">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <span class="headline">Filtros</span>
                    </v-row>
                </v-col>

                <v-col cols="12">
                    <v-menu v-model="dateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">

                        <template v-slot:activator="{ on }">
                            <v-text-field
                                label="Fecha"
                                color="accent"
                                v-model="dateRangeText"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>

                        <v-date-picker
                            v-model="dateRange"
                            no-title
                            :first-day-of-week="1"
                            locale="es-AR"
                            range
                            event-color="green lighten-1"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>

                <v-col>
                    <v-select
                        label="Estado"
                        v-model="filterState"
                        :items="optionsState"
                        multiple
                        clearable
                    >
                    </v-select>
                </v-col>
            </v-row>
        </v-container>

        <template v-slot:append>
            <v-row class="ma-4">
                <v-col cols="6">
                    <v-btn color="orange" dark block @click="onResetSelected">Resetear</v-btn>
                </v-col>

                <v-col cols="6">
                    <v-btn color="green" dark block @click="onApplySelected">Aplicar</v-btn>
                </v-col>
            </v-row>
        </template>
    </v-navigation-drawer>
</template>

<script>
    export default {
        components: {
        },

        props: {
            value: {
                type: Boolean,
                default: false
            },

            defaultFilters: Object,
            filters: Object,
            orders: Array
        },

        data() {
            return {
                active: false,
                dateMenu: false,

                dateRange: [],
                filterState: [],

                newFilters: {},

                optionsState: [
                    { text: 'Pendiente', value: 'state.open' },
                    { text: 'Completado', value: 'state.closed' },
                    { text: 'Cancelado', value: 'state.cancelled' }
                ]
            };
        },

        computed: {
            dateRangeText() {
                let dates = [ ...this.dateRange ];
                dates.sort();

                if(dates.length > 1) {
                    return dates.map(d => this.$moment(d).format('DD/MM/YYYY')).join(' al ');
                }
                else if(dates.length > 0) {
                    return this.$moment(this.dateRange[0]).format('DD/MM/YYYY');
                }
                else {
                    return '';
                }
            }
        },

        watch: {
            active(val) {
                this.$emit('input', val);
            },

            value(val) {
                this.active = val;
            },

            filters: {
                immediate: true,
                deep: true,
                handler(val) {
                    this.newFilters = { ...val };

                    if(this.newFilters.date) {
                        if(typeof this.newFilters.date === 'object') {
                            this.dateRange = [
                                ...(this.newFilters.date.gte ? [this.newFilters.date.gte] : []),
                                ...(this.newFilters.date.lte ? [this.newFilters.date.lte] : [])
                            ];
                        }
                        else {
                            this.dateRange = [ this.newFilters.date ];
                        }
                    }

                    if(this.newFilters.state) {
                        this.filterState = this.newFilters.state.split(',');
                    }
                }
            }
        },

        methods: {
            onApplySelected() {
                let dates = [ ...this.dateRange ];
                dates.sort();

                if(dates.length === 2) {
                    this.newFilters.date = {
                        gte: dates[0],
                        lte: dates[1]
                    };
                }
                else {
                    this.newFilters.date = dates[0];
                }

                if(this.filterState && this.filterState.length > 0) {
                    this.newFilters.state = this.filterState.join(',');
                }

                this.$emit('update:filters', this.newFilters);
                this.$emit('input', false);
            },

            onResetSelected() {
                let defaultFilters = JSON.parse(JSON.stringify(this.defaultFilters));
                this.$emit('update:filters', defaultFilters);
                this.$emit('input', false);
            },

            onBackSelected() {
                this.$emit('input', false);
            }
        }
    };
</script>

<style>

</style>
